class Routers {
  public static Root: DurandalRouter = null;

  public static User: DurandalRouter = null;

  public static Settings: DurandalRouter = null;
}

export default Routers;
